import 'bootstrap/js/dist/tab';
import './tabs.scss';
